export const getAppHead = () => {
  return {
    title: 'Reverse Health',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          "Reverse Health is the first women's only 12-week weight loss program that focuses on female physiology",
      },
      { hid: 'og:url', property: 'og:url', content: 'https://reverse.health' },
      { hid: 'og:title', property: 'og:title', content: 'Reverse Health' },
      {
        hid: 'og:description',
        property: 'og:description',
        content:
          "Reverse Health is the first women's only 12-week weight loss program that focuses on female physiology.",
      },
      {
        hid: 'facebook-domain-verification',
        name: 'facebook-domain-verification',
        content: 'pbnzferzi10qee09g49f28pcvhvgbz',
      },
    ],
    link: [{ hid: 'favicon', rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }],
  };
};
